export var SPRINT_CHOOSER_VISIBLE = 'SPRINT_CHOOSER_VISIBLE';
export var TASK_FILTER_VISIBLE = 'TASK_FILTER_VISIBLE';
export var CARD_DETAIL_VISIBLE = 'CARD_DETAIL_VISIBLE';
export var CARD_PROGRESS_VISIBLE = 'CARD_PROGRESS_VISIBLE';
export var CARD_AVATAR_VISIBLE = 'CARD_AVATAR_VISIBLE';
export var CARD_VIEW_FILTER = 'CARD_VIEW_FILTER';
export var CARD_DISPLAY_VERSION = 'CARD_DISPLAY_VERSION';
export var DISPLAY_CLOSED_CARDS = 'DISPLAY_CLOSED_CARDS';
export var INDEPENDENT_COLUMN_SCROLLING = 'INDEPENDENT_COLUMN_SCROLLING';



//////////////////
// WEBPACK FOOTER
// ./src/constants/localeStorageKeys.ts
// module id = 368
// module chunks = 0